export default {
  createSubjectDocument: '/subjectInstituteLevel/createSubjectDocument',
  bulkCreateSubjectDocument: '/subjectInstituteLevel/bulkCreateSubjectDocument',
  getSubjectDocumentOfAInstitute: '/subjectInstituteLevel/getSubjectDocumentOfAInstitute',
  updateSubjectDocument: '/subjectInstituteLevel/updateSubjectDocument',
  deleteSubjectDocument: '/subjectInstituteLevel/deleteSubjectDocument',
  getSingleSubjectDocument: '/subjectInstituteLevel/getSingleSubjectDocument',
}